import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-16">
          <Link
            to="/"
            className="font-heading text-xl md:text-2xl font-bold text-primary-700 tracking-tight whitespace-nowrap"
          >
            gtbuy.run
          </Link>

          <div className="flex items-center gap-3 md:gap-4">
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                <span>Shop Categories</span>
                {dropdownOpen ? (
                  <i className="ri-arrow-up-s-line text-sm"></i>
                ) : (
                  <i className="ri-arrow-down-s-line text-sm"></i>
                )}
              </button>

              {dropdownOpen && (
                <div className="absolute top-full mt-2 right-0 w-64 bg-background-50 rounded-xl shadow-lg border border-background-200/70 py-2 max-h-80 overflow-y-auto z-50">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block px-5 py-2.5 text-sm text-foreground-700 hover:bg-accent-100 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setDropdownOpen(false)}
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hidden sm:inline-flex items-center px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              GTBuy Sheet
            </a>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hidden sm:inline-flex items-center px-4 py-2 rounded-full border-2 border-primary-500 text-primary-700 text-sm font-semibold cursor-pointer whitespace-nowrap hover:bg-primary-500 hover:text-background-50 transition-colors"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}